module.exports = __webpack_public_path__ + "static/media/info-2.963024d9.png";